export function loadUserbackScript() {
  const userbackKey = process.env.VUE_APP_USERBACK_KEY;
  console.log('installing userback, key=', userbackKey);
  if (!userbackKey) {
    // userback key not set
    return;
  }

  window.Userback = window.Userback || {};
  if (window.Userback.access_token) {
    // already initialized
    return;
  }
  window.Userback.access_token = userbackKey;
  (function (id) {
    const s: any = document.createElement('script');
    s.async = 1;
    s.src = 'https://static.userback.io/widget/v1.js';
    const parent_node = document.head || document.body;
    parent_node.appendChild(s);
  })('userback-sdk');
}
